import { ResourceType } from 'routes/Menu/constants/resources'
import { getNumPortions } from 'selectors/basket'
import { getRecipe } from 'selectors/menu-recipes/getRecipe'
import { getRecipeIdByCoreId } from 'selectors/menu-recipes/getRecipeIdByCoreId'

export const getCollection = (state) => {
  const { routing } = state

  const urlCollection = routing.locationBeforeTransitions.query

  return urlCollection.collection || 'all-recipes'
}

export const getRecipeByCoreId = (coreId, state) =>
  getRecipe(getRecipeIdByCoreId(coreId)(state))(state)

export const convertRecipeIdsToHashOfQuantities = (recipeIds) =>
  recipeIds.reduce((result, recipeId) => {
    if (!result[recipeId]) {
      return { ...result, [recipeId]: 1 }
    } else {
      return { ...result, [recipeId]: result[recipeId] + 1 }
    }
  }, {})

export const getBoxTypeValue = (state) => getNumPortions(state)

const getV1OrderAPIKeys = (order) => {
  const recipes = order.recipeItems || []
  const recipeIds = recipes.map((recipe) => recipe.recipeId)
  const recipeCount = order.box.numRecipes
  const totalPrice = order.prices.total
  const orderId = order.id.toString()

  return {
    recipeIds,
    recipeCount,
    totalPrice,
    orderId,
  }
}

const getV2OrderAPIKeys = (order) => {
  const recipes = order.relationships.components.data.filter((i) => i.type === ResourceType.Recipe)
  const recipeIds = recipes.map((recipe) => recipe.meta.coreRecipeId)
  const recipeCount = recipes.length
  const totalPrice = order.attributes.prices.total
  const orderId = order.id.toString()

  return {
    recipeIds,
    recipeCount,
    totalPrice,
    orderId,
  }
}

export const getOrderDetails = (order) => {
  const fn = order.relationships ? getV2OrderAPIKeys : getV1OrderAPIKeys

  return fn(order)
}
